import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useDispatch } from 'react-redux';
import * as actions from '../_redux/collectorAction';
import * as columnFormatters from './column-formatters/';

export const CollectorDialogList = ({ id, status }) => {

	const [collectDetail, setCollectDetail] = useState([]);
	const [countRow, setCountRow] = useState(0);
	const [printUrl, setPrintUrl] = useState('');

	const dispatch = useDispatch();
	useEffect(() => {
		//Requset ke Collector Action
		dispatch(actions.fetchCollectDetail(id, status)).then(response => {
			setCollectDetail(response.rows);
			setCountRow(response.count);
			setPrintUrl(response.url_print)
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	const downloadReportClick = () => {
		window.open(printUrl)
	}

	// Table columns
	const columns = [
		{
			dataField: 'donation_hid',
			text: 'Donation HID',
		},
		{
			dataField: 'payment_edc_provider',
			text: 'Payment',
			formatter: columnFormatters.PaymentColumnFormatter,
		},
		{
			dataField: 'donation_item',
			text: 'TRX Item',
			formatter: columnFormatters.TrxItemFormatter,
		},
		{
			dataField: 'row',
			text: 'Total',
			formatter: columnFormatters.PriceTotalCount,
		},
	];

	const columnChild = [
		{
			dataField: 'name',
			text: 'Nama',
			formatter: columnFormatters.NameFormatter
		},
		{
			dataField: 'type',
			text: 'Tipe',
		},
		{
			dataField: 'amount',
			text: 'Total',
			formatter: columnFormatters.PriceAmount,
		},
	]


	const expandRow = {
		renderer: row => (
			<BootstrapTable
				wrapperClasses="table-respontesive"
				classes="table table-head-custom table-vertical-center overflow-hidden table-hover"
				striped
				bootstrap4
				bordered
				size="sm"
				remote
				keyField='uuid'
				data={row.donation_item === null ? [] : row.donation_item}
				columns={columnChild}
			/>
		),
		onlyOneExpanding: true,
		showExpandColumn: true
	};


	return (
		<>
			<BootstrapTable
				wrapperClasses="table-responsive"
				classes="table table-head-custom table-vertical-center overflow-hidden"
				bootstrap4
				bordered={false}
				remote
				keyField="uuid"
				data={collectDetail === null ? [] : collectDetail}
				columns={columns}
				expandRow={expandRow}

			>
			</BootstrapTable>
			<hr />
					<button
						type="button"
						className="btn btn-primary float-right"
						onClick={downloadReportClick}
					>Download Report
					</button>
			<h6>Total Transaksi : {countRow} item</h6>
		</>
	);
};

